import { useSlate } from "slate-react";
import { Button } from "react-bootstrap";

import { isMarkActive, toggleMark } from "../../utils/utility";

const MarkButton = ({ format, icon, trim = false }) => {
  const editor = useSlate();
  const isActive = isMarkActive(editor, format);

  const handleOnClick = (event) => {
    event.preventDefault();
    toggleMark(editor, format);
  };
  return (
    <Button
      size="sm"
      variant="white"
      active={isActive}
      onClick={handleOnClick}
      className={` border-0 ${!trim ? "me-1" : ""} ${
        isActive ? "bg-primary bg-opacity-10" : "bg-light"
      }`}
    >
      <span translate="no" className={`material-symbols-outlined md-16`}>
        {icon}
      </span>
    </Button>
  );
};

export default MarkButton;
